<template>
  <div>sender</div>
</template>

<script>
  export default {
    name: 'Sender'
  }
</script>

<style scoped>

</style>